import { render, staticRenderFns } from "./WaybillEventTimeline.vue?vue&type=template&id=63c336e0&scoped=true"
import script from "./WaybillEventTimeline.vue?vue&type=script&lang=js"
export * from "./WaybillEventTimeline.vue?vue&type=script&lang=js"
import style0 from "./WaybillEventTimeline.vue?vue&type=style&index=0&id=63c336e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c336e0",
  null
  
)

export default component.exports